import { generateArcVertices, getEntityExtrusionTransform } from "./helpers";
export function decomposeArc(entity, dxfHeaders) {
    return generateArcVertices({
        center: entity.center,
        radius: entity.radius,
        startAngle: entity.startAngle,
        endAngle: entity.endAngle,
        transform: getEntityExtrusionTransform(entity),
        dxfHeaders,
    });
}
//# sourceMappingURL=decomposeArc.js.map